import type { Business } from "@/types/directory";

export const businessesPartC: Business[] = [
  {
    id: "biz-17",
    slug: "anantha-jewellers",
    name: "Anantha Jewellers",
    tagline: "Hallmarked gold, diamond and temple jewellery since 1987",
    description:
      "A three-generation family jeweller in Mangaluru offering BIS-hallmarked gold, diamond and traditional temple jewellery, with in-house gold valuation, bespoke design and lifetime polishing for every customer.",
    categorySlug: "retail",
    subcategory: "Jewellery Showrooms",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Anantha Arcade, Car Street, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 7788",
    whatsapp: "+91 98861 47788",
    email: "care@ananthajewellers.in",
    website: "https://ananthajewellers.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Car%20Street%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20jewellery%20showroom%20interior%20with%20warm%20golden%20lighting%2C%20glass%20display%20counters%20of%20gold%20ornaments%20and%20a%20rich%20maroon%20interior%2C%20luxury%20retail%20photography&width=1200&height=800&seq=cbc-biz-anantha-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Traditional%20Indian%20gold%20temple%20jewellery%20set%20arranged%20on%20a%20dark%20velvet%20display%20tray%2C%20warm%20studio%20lighting%2C%20luxury%20product%20photography&width=1200&height=800&seq=cbc-biz-anantha-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sparkling%20diamond%20ring%20and%20necklace%20displayed%20under%20focused%20jewellery%20lighting%2C%20elegant%20luxury%20retail%20product%20photography&width=1200&height=800&seq=cbc-biz-anantha-g2-01&orientation=landscape",
    ],
    rating: 4.8,
    reviewCount: 412,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 38,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "20:30", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "19:00", closed: false },
    ],
    services: ["Gold Jewellery", "Diamond Jewellery", "Custom Design", "Gold Valuation"],
    tags: ["BIS Hallmarked", "Since 1987", "Custom Design", "Lifetime Polish"],
    reviews: [
      {
        id: "rev-17-1",
        author: "Shwetha P.",
        rating: 5,
        date: "2026-08-10",
        comment: "We bought our wedding set here. The design options were superb and the staff never rushed us.",
        verified: true,
      },
      {
        id: "rev-17-2",
        author: "Raghavendra B.",
        rating: 5,
        date: "2026-07-06",
        comment: "Transparent pricing and hallmarked gold. Free polishing for life is a lovely touch.",
        verified: true,
      },
    ],
    videoUrl: "https://www.youtube.com/shorts/ysz5S6PUM-U",
  },
  {
    id: "biz-18",
    slug: "bandhan-sweets-and-bakery",
    name: "Bandhan Sweets & Bakery",
    tagline: "Fresh Indian sweets, cakes and savouries daily",
    description:
      "A busy sweets and bakery outlet in Udupi known for Mysore pak, kajjaya, freshly baked cakes and evening savouries, with custom celebration cakes and gift hampers for every festival and occasion.",
    categorySlug: "restaurants",
    subcategory: "Sweets & Bakeries",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Maruthi Veethika, Udupi, Udupi District - 576101",
    phone: "+91 820 253 6611",
    whatsapp: "+91 98453 36611",
    email: "orders@bandhansweets.in",
    website: "https://bandhansweets.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Maruthi%20Veethika%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20inviting%20Indian%20sweet%20shop%20display%20with%20trays%20of%20colourful%20milk%20sweets%20and%20freshly%20baked%20cakes%20under%20bright%20glass%20counters%2C%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-bandhan-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Assorted%20traditional%20Indian%20sweets%20like%20Mysore%20pak%20and%20kajjaya%20arranged%20neatly%20on%20a%20brass%20tray%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-bandhan-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Freshly%20baked%20celebration%20cake%20with%20cream%20frosting%20on%20a%20bakery%20counter%2C%20soft%20warm%20lighting%2C%20bakery%20food%20photography&width=1200&height=800&seq=cbc-biz-bandhan-g2-01&orientation=landscape",
    ],
    rating: 4.6,
    reviewCount: 289,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 22,
    hours: [
      { day: "Monday", open: "08:00", close: "21:30", closed: false },
      { day: "Tuesday", open: "08:00", close: "21:30", closed: false },
      { day: "Wednesday", open: "08:00", close: "21:30", closed: false },
      { day: "Thursday", open: "08:00", close: "21:30", closed: false },
      { day: "Friday", open: "08:00", close: "22:00", closed: false },
      { day: "Saturday", open: "08:00", close: "22:00", closed: false },
      { day: "Sunday", open: "08:00", close: "21:30", closed: false },
    ],
    services: ["Indian Sweets", "Fresh Bakery", "Celebration Cakes", "Gift Hampers"],
    tags: ["Fresh Daily", "Custom Cakes", "Festive Hampers", "Takeaway"],
    reviews: [
      {
        id: "rev-18-1",
        author: "Nandini R.",
        rating: 5,
        date: "2026-08-07",
        comment: "Their Mysore pak is the best in Udupi. Always fresh and the cakes are beautifully made.",
        verified: true,
      },
      {
        id: "rev-18-2",
        author: "Kiran Hegde",
        rating: 4,
        date: "2026-07-18",
        comment: "Ordered a birthday cake and it was delivered on time. Tasted wonderful.",
        verified: true,
      },
    ],
    videoUrl: "https://vimeo.com/76979871",
  },
  {
    id: "biz-19",
    slug: "coastal-dental-studio",
    name: "Coastal Dental Studio",
    tagline: "Gentle, modern dentistry for the whole family",
    description:
      "A contemporary dental clinic in Mangaluru offering painless root canals, implants, orthodontics and cosmetic dentistry, with digital X-rays, sterilised equipment and transparent treatment plans.",
    categorySlug: "healthcare",
    subcategory: "Dental Clinics",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Shivabagh Circle, Mangaluru, Dakshina Kannada - 575002",
    phone: "+91 824 248 3322",
    whatsapp: "+91 99016 83322",
    email: "appointments@coastaldental.in",
    website: "https://coastaldental.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Shivabagh%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20dental%20clinic%20treatment%20room%20with%20clean%20white%20interior%2C%20dental%20chair%20and%20soft%20natural%20light%2C%20professional%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-coastal-dental-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20dental%20clinic%20reception%20with%20calm%20neutral%20tones%20and%20comfortable%20seating%2C%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-coastal-dental-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Advanced%20digital%20dental%20scanning%20equipment%20in%20a%20modern%20sterile%20clinic%20room%2C%20healthcare%20technology%20photography&width=1200&height=800&seq=cbc-biz-coastal-dental-g2-01&orientation=landscape",
    ],
    rating: 4.7,
    reviewCount: 241,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 12,
    hours: [
      { day: "Monday", open: "09:30", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:00", closed: false },
      { day: "Thursday", open: "09:30", close: "20:00", closed: false },
      { day: "Friday", open: "09:30", close: "20:00", closed: false },
      { day: "Saturday", open: "09:30", close: "18:00", closed: false },
      { day: "Sunday", open: "10:00", close: "13:00", closed: false },
    ],
    services: ["Root Canal", "Dental Implants", "Orthodontics", "Cosmetic Dentistry"],
    tags: ["Painless Treatment", "Digital X-Ray", "Sterilised Care", "Family Clinic"],
    reviews: [
      {
        id: "rev-19-1",
        author: "Deepika M.",
        rating: 5,
        date: "2026-08-04",
        comment: "Genuinely painless root canal. The doctor explained every step and the clinic is spotless.",
        verified: true,
      },
      {
        id: "rev-19-2",
        author: "Ananth K.",
        rating: 4,
        date: "2026-06-25",
        comment: "Modern equipment and a very gentle approach with kids. Highly recommend.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-20",
    slug: "emerald-eye-care-centre",
    name: "Emerald Eye Care Centre",
    tagline: "Complete eye care and laser vision correction",
    description:
      "An advanced eye care centre in Manipal offering comprehensive eye checkups, cataract and LASIK surgery, retina care and paediatric ophthalmology, backed by experienced surgeons and modern diagnostic technology.",
    categorySlug: "healthcare",
    subcategory: "Eye Care & Ophthalmology",
    districtSlug: "udupi",
    locationSlug: "manipal",
    address: "Eshwari Complex, Manipal, Udupi District - 576104",
    phone: "+91 820 257 4400",
    whatsapp: "+91 94486 74400",
    email: "care@emeraldeyecare.in",
    website: "https://emeraldeyecare.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Manipal%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20eye%20hospital%20examination%20room%20with%20advanced%20optical%20diagnostic%20equipment%20and%20clean%20calming%20interior%2C%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-emerald-eye-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Optometrist%20performing%20a%20routine%20eye%20examination%20on%20a%20patient%20with%20a%20slit%20lamp%20device%2C%20clean%20clinic%20photography&width=1200&height=800&seq=cbc-biz-emerald-eye-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Neat%20display%20of%20stylish%20eyeglass%20frames%20on%20an%20illuminated%20wall%20in%20a%20modern%20optical%20showroom%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-emerald-eye-g2-01&orientation=landscape",
    ],
    rating: 4.7,
    reviewCount: 318,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 15,
    hours: [
      { day: "Monday", open: "08:30", close: "19:30", closed: false },
      { day: "Tuesday", open: "08:30", close: "19:30", closed: false },
      { day: "Wednesday", open: "08:30", close: "19:30", closed: false },
      { day: "Thursday", open: "08:30", close: "19:30", closed: false },
      { day: "Friday", open: "08:30", close: "19:30", closed: false },
      { day: "Saturday", open: "08:30", close: "17:00", closed: false },
      { day: "Sunday", open: "09:30", close: "13:00", closed: false },
    ],
    services: ["Eye Checkups", "Cataract Surgery", "LASIK & Lasik", "Retina Care"],
    tags: ["Advanced Diagnostics", "Experienced Surgeons", "Optical Store", "Insurance"],
    reviews: [
      {
        id: "rev-20-1",
        author: "Prakash N.",
        rating: 5,
        date: "2026-08-13",
        comment: "My cataract surgery went perfectly. The team was reassuring and the follow-up care was excellent.",
        verified: true,
      },
      {
        id: "rev-20-2",
        author: "Roopa S.",
        rating: 4,
        date: "2026-07-02",
        comment: "Thorough eye checkup and a good choice of frames. Slight wait on a busy Saturday.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-21",
    slug: "fresh-basket-supermarket",
    name: "Fresh Basket Supermarket",
    tagline: "Everyday groceries and farm-fresh produce",
    description:
      "A spacious supermarket in Moodabidri stocking fresh fruit and vegetables, branded groceries, dairy, bakery and household essentials, with quick billing and home delivery across the town.",
    categorySlug: "supermarkets",
    subcategory: "Supermarkets",
    districtSlug: "south-canara",
    locationSlug: "moodabidri",
    address: "Main Road, Moodabidri, Dakshina Kannada - 574227",
    phone: "+91 8258 237 900",
    whatsapp: "+91 97397 37900",
    email: "orders@freshbasket.in",
    website: "https://freshbasketmoodabidri.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Moodabidri%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20spacious%20modern%20supermarket%20aisle%20with%20neatly%20stacked%20groceries%20and%20fresh%20produce%20under%20clean%20lighting%2C%20appealing%20retail%20interior%20photography&width=1200&height=800&seq=cbc-biz-fresh-basket-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Colourful%20fresh%20fruits%20and%20vegetables%20neatly%20arranged%20in%20a%20modern%20supermarket%20display%2C%20bright%20lighting%2C%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-fresh-basket-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Clean%20supermarket%20checkout%20counter%20with%20stocked%20shelves%20behind%2C%20bright%20organized%20retail%20photography&width=1200&height=800&seq=cbc-biz-fresh-basket-g2-01&orientation=landscape",
    ],
    rating: 4.4,
    reviewCount: 168,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 8,
    hours: [
      { day: "Monday", open: "07:30", close: "21:30", closed: false },
      { day: "Tuesday", open: "07:30", close: "21:30", closed: false },
      { day: "Wednesday", open: "07:30", close: "21:30", closed: false },
      { day: "Thursday", open: "07:30", close: "21:30", closed: false },
      { day: "Friday", open: "07:30", close: "21:30", closed: false },
      { day: "Saturday", open: "07:30", close: "22:00", closed: false },
      { day: "Sunday", open: "07:30", close: "21:00", closed: false },
    ],
    services: ["Fresh Produce", "Grocery", "Home Delivery", "Bulk Orders"],
    tags: ["Farm Fresh", "Home Delivery", "Branded Groceries", "UPI Accepted"],
    reviews: [
      {
        id: "rev-21-1",
        author: "Sudha N.",
        rating: 5,
        date: "2026-08-08",
        comment: "Big store, everything under one roof and the delivery is quick. My weekly stop now.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-22",
    slug: "gitanjali-silk-house",
    name: "Gitanjali Silk House",
    tagline: "Handpicked silk sarees and bridal collections",
    description:
      "A curated saree store in Udupi offering Karnataka and Kanchipuram silk sarees, bridal collections, designer blouses and festive wear, with personal styling assistance and in-house tailoring.",
    categorySlug: "retail",
    subcategory: "Silk & Sarees",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Diana Circle, Udupi, Udupi District - 576101",
    phone: "+91 820 252 8120",
    whatsapp: "+91 98804 78120",
    email: "shop@gitanjalisilks.in",
    website: "https://gitanjalisilks.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Diana%20Circle%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Rich%20traditional%20saree%20showroom%20interior%20with%20neatly%20stacked%20colourful%20silk%20sarees%20on%20shelves%20and%20warm%20inviting%20lighting%2C%20Indian%20bridal%20retail%20photography&width=1200&height=800&seq=cbc-biz-gitanjali-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Elegant%20Kanchipuram%20silk%20saree%20with%20gold%20zari%20border%20displayed%20on%20a%20mannequin%2C%20warm%20studio%20lighting%2C%20textile%20product%20photography&width=1200&height=800&seq=cbc-biz-gitanjali-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Colourful%20folded%20silk%20sarees%20arranged%20in%20a%20neat%20stack%20on%20a%20display%20table%2C%20warm%20retail%20lighting%2C%20textile%20photography&width=1200&height=800&seq=cbc-biz-gitanjali-g2-01&orientation=landscape",
    ],
    rating: 4.6,
    reviewCount: 203,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 19,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "20:00", closed: false },
    ],
    services: ["Silk Sarees", "Bridal Collection", "Designer Blouses", "Tailoring"],
    tags: ["Kanchipuram Silk", "Bridal Wear", "Custom Blouses", "Since 2006"],
    reviews: [
      {
        id: "rev-22-1",
        author: "Vaishnavi K.",
        rating: 5,
        date: "2026-08-02",
        comment: "Bought my wedding saree here. Huge collection and the staff helped match the blouse perfectly.",
        verified: true,
      },
      {
        id: "rev-22-2",
        author: "Girija Bhat",
        rating: 4,
        date: "2026-07-14",
        comment: "Beautiful silk collection with fair prices. Tailoring was neat and on time.",
        verified: true,
      },
    ],
  },
];